module.exports = __webpack_public_path__ + "assets/img/newimglr.5c6535e4.png";